import { buildQuery } from "../lib/network";
import { coreService } from "../services/coreService";
import { FirstArgumentType } from "../types/ArgumentTypes";

export const getDocumentDownload = (networkHeaders: any) => (id: string) => {
  return buildQuery(coreService.documentsDownloadDetail(parseInt(id), { headers: networkHeaders }), (response) => {
    return { s3SignedUrl: response.data.signedUrl };
  });
};

export const postGenerateTestDocument =
  (networkHeaders: any) => (data: FirstArgumentType<typeof coreService.documentsGenerateTestCreate>) => {
    return buildQuery(coreService.documentsGenerateTestCreate(data, { headers: networkHeaders }), (response) => {
      return response.data;
    });
  };
